export enum ApproveStatus {
  NotApproved,
  Seen,
  Accepted,
  Rejected,
}

export const ApproveStatusPriority = [
  ApproveStatus.Rejected,
  ApproveStatus.NotApproved,
  ApproveStatus.Seen,
  ApproveStatus.Accepted,
];
